import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { generativeAiStandardsRulesetSynthesisUsage } from "./constants";
import type { GenerativeAiStandardsRulesetSynthesisUsageResult } from "./types";
import { isGenerativeAiStandardsRulesetSynthesisUsageResult } from "./validators";

/**
 * GET handler for the "/:app_group_id/generative_ai/standards_ruleset_synthesis_usage" endpoint
 */
export const getGenerativeAiStandardsRulesetSynthesisUsage = reactQueryFetcherAdapter(
  generativeAiStandardsRulesetSynthesisUsage,
  (signal: AbortSignal, appGroupId: string): Promise<GenerativeAiStandardsRulesetSynthesisUsageResult> => {
    return fetch(`/${appGroupId}/generative_ai/standards_ruleset_synthesis_usage`, "GET", {}, { signal });
  },
  isGenerativeAiStandardsRulesetSynthesisUsageResult
);
